import React from 'react';
import { observer } from 'mobx-react';
import moment from 'moment';

let AccountStateButton = ({ ...props }) => {
    //default active text 
    let display_text = "Active"; 
    //default active style
    let display_type = "success";

    let account = props.store.accounts.getById(props.accountId);



    const accountStatus = account.getAccountStatus();

    if (accountStatus) {
        if (accountStatus.status === "Locked") {
            display_text = "Locked";
            display_type = "danger";
        }
    }
    
    if (props.badge) {
        return (
            <button onClick={props.redirectToTarget} value={account.id} style={{ display: "block", border:"none" }} type="button" className={"badge badge-" + display_type} >
                {display_text}
            </button>
        )
    }


    return (
        <button onClick={props.redirectToTarget}  value={account.id} style={{ display: "block" }} type="button" className={"btn btn-" + display_type} >
            {display_text}
        </button>
    )
}

AccountStateButton = observer(AccountStateButton)

export default AccountStateButton;

